<template>
  <v-container id="galery" tag="section">
     <!-- =======================================================
                                Overlay
    ============================================================-->
    <v-overlay :value="overlay">
      <v-progress-circular :size="70" :width="7" color="blue" indeterminate></v-progress-circular>
    </v-overlay>

    <!-- =======================================================
                                Dialog
    ============================================================-->    
    <div class="text-center">
      <v-dialog v-model="dialog.value" width="500">
        <v-card>
          <v-card-title class="headline red white--text">
            <v-spacer />
            {{dialog.title}}
            <v-spacer />
          </v-card-title>

          <v-card-text class="mt-5">{{dialog.message}}</v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-btn text @click="dialogClear()">Não</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog.action()">Sim</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- =======================================================
                                Main
    ============================================================-->
    <v-btn color="green" class="ma-2 white--text" to="/pages/gallery/create">
      <v-icon left dark>mdi-plus</v-icon>Adicionar
    </v-btn>

    <tables
      :title="title"
      :columns="columns"
      :linesData="linesData"
      @action="action($event)"
      :actionsOptions="actionsOptions"
    />
  </v-container>
</template>

<script>
import galleryService from "../../../../service/galleryService";

export default {
  name: "gallery",
  components: {
    Tables: () => import("../../../../components/cms/Tables")
  },
  data: () => ({
    title: "Galerias Cadastradas",
    columns: ["Nome", "Categoria", "Data da postagem", "Ações"],
    actionsOptions: ["edit", "delete"],
    linesData: [],
    approvedDialog: false,
    overlay: false,
    dialog: {
      title: "",
      message: "",
      type: "",
      id: "",
      value: false,
      action: null
    }
  }),
  methods: {
    action($event) {
      switch ($event.type) {
        case "edit":
          this.edit($event.id);
          break;
        case "delete":
          const data = {
            title: "Excluir galeria",
            message: "Deseja excluir essa galeria?",
            type: "delete",
            id: $event.id,
            action: this.deleteGalery
          };
          this.dialogAction(data);
          break;
        default:
          break;
      }
    },
    dialogAction(data) {
      this.dialog = Object.assign({}, data);
      this.dialog.value = true;
    },
    dialogClear() {
      this.dialog = {
        title: "",
        message: "",
        type: "",
        id: "",
        value: false,
        action: null
      };
    },
    getAll() {
      this.overlay = true;
      galleryService.get({all:true}).then(res => {
        this.overlay = false;
        this.linesData = res.data.map(galery => {
          return {
            id: galery.id,
            id_category: galery.id_category,
            lines: [
              {width:50 ,name:galery.title},
              {width:20 ,name:galery.category},
              {width:15 ,name:galery.date}
            ]
          };
        });
      });
    },
    edit(id) {
      this.$router.push({ path: `gallery/edit/${id}` });
    },
    deleteGalery() {
      galleryService.delete(this.dialog.id).then(res => {
        this.getAll();
        this.dialogClear();
      });
    }
  },
  mounted() {
    this.getAll();
  }
};
</script>
